module.exports = __webpack_public_path__ + "media/images/amenities_icons/facebook-0ecbd541c032f9da664c889184fa6f83.svg";